// JOBE-0106: EntitiesByKindGrid — 2-up grid of `kbox` tiles from
// `counts.entities_by_kind`. Each tile links to
// `/projects/{urn}/entities/{kind}` (Phase 6 destination — the route
// itself is Phase 6's responsibility; this spec authors only the link).

import React from 'react';
import { Link } from 'react-router-dom';

export function EntitiesByKindGrid({ projectURN, entitiesByKind }) {
  const entries = entitiesByKind
    ? Object.entries(entitiesByKind).sort(([a], [b]) => a.localeCompare(b))
    : [];

  if (entries.length === 0) {
    return (
      <section className="project-entities-by-kind" data-testid="entities-by-kind">
        <h3 className="lane-title">Entities by kind</h3>
        <p className="muted">No entities yet.</p>
      </section>
    );
  }

  return (
    <section className="project-entities-by-kind" data-testid="entities-by-kind">
      <h3 className="lane-title">Entities by kind</h3>
      <div className="kbox-grid">
        {entries.map(([kind, count]) => (
          <Link
            key={kind}
            to={`/projects/${encodeURIComponent(projectURN)}/entities/${encodeURIComponent(kind)}`}
            className="kbox"
            data-testid={`kbox-${kind}`}
            data-kind={kind}
          >
            <span className="kbox-kind mono">{kind}</span>
            <span className="kbox-count">{count}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
